import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="results-title" data-id="element-151" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-152" data-mp="28ddhl9rhabqq">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-navy-900 sm:text-4xl" data-id="element-153" data-mp="2d6zvt6dainon">
          Lo que dicen los docentes que ya tienen su Megapack
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-154" data-mp="2m63ei98jp12m">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-navy-100 bg-canvas p-6 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-155" data-mp="2r70tkcy9dezw" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-leaf-600" aria-hidden="true" data-id="element-156" data-mp="3nfitkfa287ig" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-navy-700" data-id="element-157" data-mp="3il4wm8fr1sbo">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-navy-100 pt-4" data-id="element-158" data-mp="3dnw9rujnp043">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-navy-900 text-sm font-extrabold text-white" data-id="element-159" data-mp="38q4h2yb6t9yu">
                  {initials}
                </span>
                <span data-id="element-160" data-mp="58ckf6m3w1ub">
                  <b className="block text-sm text-navy-900" data-id="element-161" data-mp="5606d4jgybmj">{name}</b>
                  <small className="text-xs text-navy-700/80" data-id="element-162" data-mp="75cn7jyr2nn">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}